export default "__VITE_ASSET__CGMlvr6O__"